export default {
    mainRed: "var(--red)",
    dark: "var(--secondary)",
    light: "var(--primary)",
    white: "var(--white)",
    black: "var(--black)",
    background: "var(--background)"
};
